<template>
    <div>
        <!-- Repeats Every Section -->
        <div class="flex flex-wrap -mx-2 items-center mb-4">
            <label class="w-full md:w-1/3 block text-gray-700 px-2">Repeats every</label>
            <div class="w-1/3 px-2">
                <maz-input
                    v-model="recurring.interval"
                    name="interval"
                    type="number"
                    :min="1"
                />
            </div>
            <div class="w-2/3 md:w-1/3 px-2">
                <multiselect
                    v-model="recurring.repeats_type"
                    :options="repeatOptions"
                    track-by="value"
                    label="text"
                    select-label=""
                    deselect-label=""
                    :allow-empty="false"
                />
            </div>
        </div>

        <!-- Repeat On (Weekly) Section -->
        <div v-if="recurring.repeats_type?.value === 'WEEKLY'">
            <label class="w-full block text-gray-700 mt-2 pb-1">Repeat On</label>
            <div class="flex flex-wrap justify-start sm:justify-between mb-4 space-x-2 sm:space-x-0">
                 <!-- Added flex-wrap and spacing for smaller screens -->
                <div class="flex items-center space-x-1 sm:space-x-2 mb-1 sm:mb-0">
                    <input type="checkbox" id="sun" value="SU" name="repeats_on" v-model="recurring.repeats_on" class="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out">
                    <label for="sun" class="font-medium text-gray-700">Sun</label>
                </div>
                <div class="flex items-center space-x-1 sm:space-x-2 mb-1 sm:mb-0">
                    <input type="checkbox" id="mon" value="MO" name="repeats_on" v-model="recurring.repeats_on" class="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out">
                    <label for="mon" class="font-medium text-gray-700">Mon</label>
                </div>
                <div class="flex items-center space-x-1 sm:space-x-2 mb-1 sm:mb-0">
                    <input type="checkbox" id="tue" value="TU" name="repeats_on" v-model="recurring.repeats_on" class="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out">
                    <label for="tue" class="font-medium text-gray-700">Tue</label>
                </div>
                <div class="flex items-center space-x-1 sm:space-x-2 mb-1 sm:mb-0">
                    <input type="checkbox" id="wed" value="WE" name="repeats_on" v-model="recurring.repeats_on" class="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out">
                    <label for="wed" class="font-medium text-gray-700">Wed</label>
                </div>
                <div class="flex items-center space-x-1 sm:space-x-2 mb-1 sm:mb-0">
                    <input type="checkbox" id="thu" value="TH" name="repeats_on" v-model="recurring.repeats_on" class="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out">
                    <label for="thu" class="font-medium text-gray-700">Thu</label>
                </div>
                <div class="flex items-center space-x-1 sm:space-x-2 mb-1 sm:mb-0">
                    <input type="checkbox" id="fri" value="FR" name="repeats_on" v-model="recurring.repeats_on" class="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out">
                    <label for="fri" class="font-medium text-gray-700">Fri</label>
                </div>
                <div class="flex items-center space-x-1 sm:space-x-2 mb-1 sm:mb-0">
                    <input type="checkbox" id="sat" value="SA" name="repeats_on" v-model="recurring.repeats_on" class="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out">
                    <label for="sat" class="font-medium text-gray-700">Sat</label>
                </div>
            </div>
        </div>

        <!-- Start Date & Time Section -->
        <div class="">
            <label class="w-full block text-gray-700" for="start-date-picker">Start Date</label>
            <maz-picker
                id="start-date-picker"
                class="w-full relative"
                :model-value="start_date"
                @update:model-value="handleStartDateChange"
                :required="true"
                format="YYYY-MM-DD"
                display-format="MMM D, YYYY"
                :min-date="minStartDate"
            />

            <label class="w-full block text-gray-700 mt-4">Send Time</label>
            <div class="flex -mx-2">
                <multiselect
                    class="w-1/3 mx-2"
                    v-model="send_hour"
                    :options="hourOptions"
                    select-label=""
                    deselect-label=""
                    :allow-empty="false"
                />
                <multiselect
                    class="w-1/3 mx-2"
                    v-model="send_min"
                    :options="minuteOptions"
                    select-label=""
                    deselect-label=""
                    :allow-empty="false"
                />
                <multiselect
                    class="w-1/3 mx-2"
                    v-model="send_period"
                    :options="periodOptions"
                    select-label=""
                    deselect-label=""
                    :allow-empty="false"
                />
            </div>
        </div>

        <!-- Ends Section -->
        <div>
            <label class="w-full block text-gray-700 mt-4">Ends</label>
            <div>
                <label class="flex items-center mb-4 cursor-pointer">
                    <maz-radio
                        name="recurring_ends"
                        v-model="recurring.recurring_ends"
                        value="never"
                    />
                    <span class="ml-2 font-normal text-gray-700">Never</span>
                </label>

                <label class="flex items-center mb-4">
                    <div class="w-auto flex items-center mr-2 cursor-pointer">
                         <maz-radio
                            name="recurring_ends"
                            v-model="recurring.recurring_ends"
                            value="on_date"
                         />
                        <span class="ml-2 font-normal text-gray-700">On</span>
                    </div>
                    <div class="flex-grow">
                        <maz-picker
                            id="end-date-picker"
                            class="w-full relative"
                            :model-value="end_date"
                            @update:model-value="handleEndDateChange"
                            format="YYYY-MM-DD"
                            display-format="MMM D, YYYY"
                            :disabled="recurring.recurring_ends !== 'on_date'"
                            :min-date="minEndDate"
                            placeholder="Select end date"
                        />
                    </div>
                </label>

                <label class="flex items-center">
                    <div class="w-auto flex items-center mr-2 cursor-pointer">
                        <maz-radio
                            name="recurring_ends"
                            v-model="recurring.recurring_ends"
                            value="after_count"
                        />
                        <span class="ml-2 font-normal text-gray-700">After</span>
                    </div>
                    <div class="flex-grow flex items-center occurrences">
                        <maz-input
                            class="w-1/3 rounded-r-none"
                            v-model="recurring.count"
                            name="count"
                            type="number"
                            :min="1"
                            :disabled="recurring.recurring_ends !== 'after_count'"
                            @click="selectAfterCountRadio"
                        />
                        <p class="w-2/3 p-2 border rounded border-l-0 font-normal rounded-l-none bg-gray-100 text-gray-700 text-center" :class="{ 'opacity-50 cursor-not-allowed' : recurring.recurring_ends !== 'after_count', 'font-bold': recurring.recurring_ends === 'after_count' }">
                            <span v-if="recurring.count == 1 || !recurring.count">occurrence</span>
                            <span v-else>occurrences</span>
                        </p>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        modelValue: {
            type: Object,
            default: () => ({}) // Default to empty object
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            minStartDate: moment().format('YYYY-MM-DD'), // Today
            send_hour: '12', // Default time
            send_min: '00',
            send_period: 'AM',
            start_date: null, // Initialize as null, set in mounted/init
            end_date: null, // Initialize as null
            recurring: {
                interval: 1,
                repeats_type: { value: 'DAILY', text: 'day' }, // Default repeat type (object form)
                repeats_on: [],
                recurring_ends: 'never', // Default end condition
                count: 1,
            },
            // Define options here for maintainability
            hourOptions: ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
            minuteOptions: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
            periodOptions: ['AM', 'PM'],
        };
    },
    computed: {
        // Options for the repeat type dropdown, depends on interval
        repeatOptions() {
            const interval = Number(this.recurring.interval) || 1;
            return [
                { value: 'DAILY', text: interval === 1 ? 'day' : 'days' },
                { value: 'WEEKLY', text: interval === 1 ? 'week' : 'weeks' },
                { value: 'MONTHLY', text: interval === 1 ? 'month' : 'months' },
                { value: 'YEARLY', text: interval === 1 ? 'year' : 'years' },
            ];
        },
        // Calculate minimum end date (must be same day or after start date)
        minEndDate() {
            return this.start_date || this.minStartDate;
        },
        // Generates the start date string in 'YYYY-MM-DD HH:MM' format (24-hour) for emission
        startDateWithTime() {
            if (!this.start_date || !moment(this.start_date, 'YYYY-MM-DD', true).isValid()) {
                return null; // Return null if date is invalid/missing
            }

            let hour24 = parseInt(this.send_hour, 10);
            if (this.send_period === 'PM' && hour24 !== 12) {
                hour24 += 12;
            } else if (this.send_period === 'AM' && hour24 === 12) {
                hour24 = 0; // Midnight case
            }

            const formattedHour = String(hour24).padStart(2, '0');
            // Ensure minute is also padded (it should be already based on options, but belt-and-suspenders)
            const formattedMin = String(this.send_min).padStart(2, '0');

            return `${this.start_date} ${formattedHour}:${formattedMin}`;
        },
        // Generates the end date string in 'YYYY-MM-DD HH:MM' format (24-hour) for emission
        endDateWithTime() {
            // Only calculate if ending 'on_date' and date is selected and valid
            if (this.recurring.recurring_ends !== 'on_date' || !this.end_date || !moment(this.end_date, 'YYYY-MM-DD', true).isValid()) {
                return null;
            }

            // Use the same time logic as start date for consistency on the end date
            let hour24 = parseInt(this.send_hour, 10);
             if (this.send_period === 'PM' && hour24 !== 12) {
                hour24 += 12;
            } else if (this.send_period === 'AM' && hour24 === 12) {
                hour24 = 0;
            }

            const formattedHour = String(hour24).padStart(2, '0');
            const formattedMin = String(this.send_min).padStart(2, '0');

            return `${this.end_date} ${formattedHour}:${formattedMin}`;
        },
        // The final data object to be emitted
        formData() {
            return {
                interval: Number(this.recurring.interval) || 1, // Ensure interval is a number
                repeats_type: this.recurring.repeats_type?.value || 'DAILY', // Safely access value
                repeats_on: this.recurring.repeats_type?.value === 'WEEKLY' ? this.recurring.repeats_on : [], // Only send repeats_on if type is weekly
                recurring_ends: this.recurring.recurring_ends,
                // Only include count if recurring_ends is 'after_count'
                count: this.recurring.recurring_ends === 'after_count' ? (Number(this.recurring.count) || 1) : null,
                 // Only include end_date if recurring_ends is 'on_date'
                end_date: this.recurring.recurring_ends === 'on_date' ? this.endDateWithTime : null,
                start_date: this.startDateWithTime,
            };
        }
    },
    methods: {
        handleStartDateChange(date) {
            // Ensure the date received from picker is valid before setting
            if (moment(date, 'YYYY-MM-DD', true).isValid()) {
                 this.start_date = date;
                 // If end date exists and is now before the new start date, clear it or adjust it
                 if (this.end_date && moment(this.end_date).isBefore(this.start_date)) {
                    this.end_date = null; // or this.end_date = this.start_date;
                 }
            } else {
                this.start_date = moment().format('YYYY-MM-DD'); // Fallback to today if invalid
            }
        },
        handleEndDateChange(date) {
             if (moment(date, 'YYYY-MM-DD', true).isValid()) {
                 this.end_date = date;
                 // Automatically select the 'On' radio button when a date is picked
                 this.recurring.recurring_ends = 'on_date';
             } else {
                 this.end_date = null;
             }
        },
        // Select the 'After X occurrences' radio when the count input is clicked
        selectAfterCountRadio() {
            if(this.recurring.recurring_ends !== 'after_count') {
                 this.recurring.recurring_ends = 'after_count';
            }
        },

        // Initialize component state based on modelValue or defaults
        initRecurringFields() {
            // --- Set Defaults First ---
            const today = moment().format('YYYY-MM-DD');
            this.minStartDate = today;
            this.start_date = today;
            this.end_date = null;
            this.send_hour = '12';
            this.send_min = '00';
            this.send_period = 'AM';
            this.recurring = { // Reset recurring object fully
                interval: 1,
                repeats_type: { value: 'DAILY', text: 'day' },
                repeats_on: [],
                recurring_ends: 'never',
                count: 1,
            };

            // --- Override with modelValue if provided ---
            const value = this.modelValue;
            if (value && Object.keys(value).length > 0) {

                // Parse Start Date & Time
                if (value.start_date) {
                    // Try parsing known formats (backend format first, then legacy format)
                    const startMoment = moment(value.start_date, [
                        "YYYY-MM-DD HH:mm",
                        "MM-DD-YYYY hh:mm A",
                        "MM-DD-YYYY h:mm a",
                    ], true);
                    if (startMoment.isValid()) {
                        this.start_date = startMoment.format('YYYY-MM-DD');
                        this.send_hour = startMoment.format('h'); // 1-12
                        this.send_min = startMoment.format('mm'); // 00-59
                        this.send_period = startMoment.format('A'); // AM/PM
                    } else {
                        console.warn("RecurringInput: Could not parse incoming start_date:", value.start_date, ". Using default.");
                        // Keep default start_date (today)
                    }
                }
                // Ensure start date is not before minStartDate (today)
                 if(moment(this.start_date).isBefore(this.minStartDate)) {
                     this.start_date = this.minStartDate;
                 }


                // Parse End Date (only date part needed internally)
                if (value.end_date) {
                     // Try parsing known formats
                    const endMoment = moment(value.end_date, ["YYYY-MM-DD HH:mm:ss", "MM-DD-YYYY hh:mm A"], true);
                     if (endMoment.isValid() && endMoment.isSameOrAfter(this.start_date, 'day')) { // Ensure end date is not before start date
                        this.end_date = endMoment.format('YYYY-MM-DD');
                    } else {
                         console.warn("RecurringInput: Could not parse incoming end_date or it's before start_date:", value.end_date, ". Ignoring.");
                         this.end_date = null; // Reset if invalid or before start
                    }
                }
                
                if (this.end_date) {
                    this.recurring.recurring_ends = 'on_date';
                }

                // Set Recurring Fields
                this.recurring.interval = value.interval;
                this.recurring.count = value.count;
                this.recurring.repeats_on = Array.isArray(value.repeats_on) ? value.repeats_on : [];

                
                const foundOption = this.repeatOptions.find(opt => opt.value === value.repeats_type);
                this.recurring.repeats_type = foundOption || { value: 'DAILY', text: 'day' }; // Fallback

                if (value.count) {
                    this.recurring.recurring_ends = 'after_count';
                    this.recurring.count = value.count;
                }

            }
        }
    },
    watch: {
        // Watch the computed formData and emit update event
        formData: {
            handler(newValue) {
                // Check if the new value is substantially different from the prop to avoid infinite loops
                 // (Simple check, might need deep comparison if objects get complex)
                if (JSON.stringify(newValue) !== JSON.stringify(this.modelValue)) {
                     this.$emit('update:modelValue', newValue);
                }
            },
            deep: true, // Needed because formData is an object
            // immediate: true // Optional: emit initial value right away
        },
        // When recurring_ends changes, ensure conflicting data is nulled
        'recurring.recurring_ends': function(newValue) {
            if (newValue === 'never') {
                this.end_date = null;
                // Decide if you want to reset count: this.recurring.count = 1;
            } else if (newValue === 'on_date') {
                // If no end_date is set yet, maybe default it?
                if (!this.end_date) {
                    this.end_date = moment(this.start_date || this.minStartDate).add(this.recurring.interval || 1, this.recurring.repeats_type?.value?.toLowerCase().slice(0, -2) || 'days').format('YYYY-MM-DD');
                }
                // Decide if you want to reset count: this.recurring.count = 1;
            } else if (newValue === 'after_count') {
                this.end_date = null;
                 if (!this.recurring.count || this.recurring.count < 1) {
                      this.recurring.count = 1; // Ensure count is at least 1
                 }
            }
        },
        // Update repeatOptions text when interval changes
        'recurring.interval': function() {
            // Need to re-find the current selection object based on its value,
            // because the 'text' part in repeatOptions has changed.
             const currentValue = this.recurring.repeats_type?.value;
             if (currentValue) {
                 const newOption = this.repeatOptions.find(opt => opt.value === currentValue);
                 if (newOption) {
                    this.recurring.repeats_type = newOption;
                 }
             }
        },
    },
    mounted() {
        console.log("ModelValue:", this.modelValue);
        this.initRecurringFields();
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<!-- Or '@vueform/multiselect/themes/default.css' -->

<style scoped>
/* Add any component-specific styles here */
.occurrences .maz-input input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
     /* Ensure input doesn't overlap the text part */
     position: relative;
     z-index: 1;
}
.occurrences p {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none; /* Adjust border for seamless look */
    /* Make text vertically centered */
    display: flex;
    align-items: center;
    justify-content: center;
}
/* Improve focus state for accessibility on radio labels */
label:has(input[type="radio"]:focus-visible) {
  outline: 2px solid blue; /* Or your preferred focus style */
  outline-offset: 2px;
  border-radius: 4px;
}
/* Ensure multiselect dropdowns appear above other elements if needed */
.multiselect {
    position: relative;
    z-index: 10; /* Adjust z-index as necessary */
}
</style>